import { render, staticRenderFns } from "./cottageSlots.vue?vue&type=template&id=15078ea4"
import script from "./cottageSlots.vue?vue&type=script&lang=js"
export * from "./cottageSlots.vue?vue&type=script&lang=js"
import style0 from "./cottageSlots.vue?vue&type=style&index=0&id=15078ea4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports